var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.563 7.36h11.25A.188.188 0 0019 7.171V5.859a.188.188 0 00-.188-.187H7.563a.188.188 0 00-.187.187v1.313c0 .103.084.187.188.187zm-.188 4.78c0 .104.084.188.188.188h11.25a.188.188 0 00.187-.187v-1.313a.188.188 0 00-.188-.187H7.563a.188.188 0 00-.187.187v1.313zM19.188.75H.813a.188.188 0 00-.188.188V2.25c0 .103.084.188.188.188h18.375a.188.188 0 00.187-.188V.937a.188.188 0 00-.188-.187zm0 14.813H.813a.188.188 0 00-.188.187v1.313c0 .103.084.187.188.187h18.375a.188.188 0 00.187-.188V15.75a.188.188 0 00-.188-.188zM.704 9.162l3.663 2.885a.208.208 0 00.337-.162v-5.77c0-.174-.199-.27-.337-.162L.705 8.838a.205.205 0 000 .324z",
    fill: "#ED1B2E"
  })));
}

export default SvgCloseMenu;